import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsPageNotFoundWidget" */ './SportsPageNotFoundWidget'),
  modules: ['./SportsPageNotFoundWidget'],
  loading: () => <div />
});

export default LoadableWidget;
